module.exports = __webpack_public_path__ + "img/fondo-mov.3db16246.webp";